import React, { useEffect, useContext } from 'react'
import { observer } from 'mobx-react'
import { useHistory, useParams, useLocation } from 'react-router'
import { Link, Route, Switch } from 'react-router-dom'
import ServerError from '../../../lib/components/ServerError'
import Button from '../../../lib/components/Button'
import StoreContext from '../../providers/storesContext'
import Spinner from '../../components/Spinner'
import {
  CASE_CHECKOUT,
  CASE_DETAIL,
  CASE_SUCCESS,
  CASE_RELEASE,
  CASE_RELEASE_SUCCESS,
  CASE_RELEASE_DROP_OFF,
  SCAN_SEARCH,
  HOME
} from '../../routing/paths'
import CaseDetail from '../../scenes/CaseDetail'
import CaseCheckout from '../../scenes/CaseCheckout'
import CaseSuccess from '../../scenes/CaseSuccess'
import CaseSelfRelease from '../../scenes/CaseSelfRelease'
import CaseSelfReleaseSuccess from '../../scenes/CaseSelfReleaseSuccess'
import CaseSelfReleaseDropOff from '../../scenes/CaseSelfReleaseDropOff'
import Error404 from '../../scenes/Error404'
import { topBarStore } from '../../../lib/stores/TopBarStore'
import { ChevronLeftIcon } from '@heroicons/react/outline'

const CaseSwitch = () => {
  const { caseDetailStore } = useContext(StoreContext)
  const { slug } = useParams()
  const history = useHistory()
  const location = useLocation()

  const { immobilizationCase, isLoading, caseLoadError } = caseDetailStore

  useEffect(() => {
    if (immobilizationCase) {
      topBarStore.setAuthAction(<div className='text-white font-bold'> {caseDetailStore.immobilizationCase.license?.number} - {caseDetailStore.immobilizationCase.license?.state} </div>)
      topBarStore.setActionIcon(
        <button onClick={history.goBack}>
          <ChevronLeftIcon className="h-6 w-6" />
        </button>
      )
    } else {
      const releaseMethod = new URLSearchParams(location.search).get('release-method')
      if (releaseMethod) {
        caseDetailStore.selectReleaseMethod(releaseMethod)
      }
      caseDetailStore.loadCaseBySlug(slug, releaseMethod).then(() => {
        if (caseDetailStore.caseLoadError) {
          history.push(SCAN_SEARCH, { errorLoad: caseDetailStore.caseLoadError })
          return
        }
        topBarStore.setAuthAction(<div className='text-white font-bold'> {caseDetailStore.immobilizationCase.license?.number} - {caseDetailStore.immobilizationCase.license?.state} </div>)
        topBarStore.setActionIcon(
          <button onClick={history.goBack}>
            <ChevronLeftIcon className="h-6 w-6" />
          </button>
        )
      })
    }
      
    return () => {
      topBarStore.reset()
    }
  }, [])

  if (!isLoading && caseLoadError !== null) {
    return (
      <div className="flex flex-1 flex-col justify-center">
        <ServerError message={caseLoadError} />
        <div className="mt-8">
          <Button as={Link} to="/">
            Go Back Home
          </Button>
        </div>
      </div>
    )
  }

  if (isLoading || !immobilizationCase) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <Spinner color="text-primary-light" size={10} />
      </div>
    )
  }

  return (
    <Switch>
      <Route exact path={CASE_RELEASE_DROP_OFF} component={CaseSelfReleaseDropOff} />
      <Route exact path={CASE_RELEASE_SUCCESS} component={CaseSelfReleaseSuccess} />
      <Route exact path={CASE_RELEASE} component={CaseSelfRelease} />
      <Route exact path={CASE_CHECKOUT} component={CaseCheckout} />
      <Route exact path={CASE_SUCCESS} component={CaseSuccess} />
      <Route exact path={CASE_DETAIL} component={CaseDetail} />
      <Route component={Error404} />
    </Switch>
  )
}

export default observer(CaseSwitch)
